const firstNameColSetting = {
  'sm-pc': '400px',
  tablet: '300px',
};

export const adjustFirstNameColSetting = (deviceType) => {
  return firstNameColSetting[deviceType] || '300px';
};

const removeColSetting = {
  'sm-pc': '100px',
  tablet: '60px',
};

export const adjustDeleteColSetting = (deviceType) => {
  return removeColSetting[deviceType] || '60px';
};

const albumAndPlaylistColSetting = {
  'sm-pc': '250px',
  tablet: '400px',
};

export const adjustAlbumAndPlaylistColSetting = (deviceType) => {
  return albumAndPlaylistColSetting[deviceType] || '60px';
};
